import { Controller } from '@hotwired/stimulus';
import GLightbox from 'glightbox';

export default class extends Controller {
  connect() {
    const { selector } = this.element.dataset;
    if (!selector) {
      throw new Error('Se debe de configurar el selector a utilzar para buscar las imágenes');
    }
    this.glbox = new GLightbox({
      selector,
    });
  }
}
